const currencies = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    CAD: "$",
    INR: "₹"
}
const urlPermissions = {
    dashboard: [ '/dashboard' ],
    campaigns: [
        '/campaigns',
        '/campaigns/create',
        '/campaigns/edit/:id'
    ],
    teams: [
        '/teams',
        '/teams/create',
        '/teams/edit/:id'
    ],
    donors: [
        '/donors',
        '/donors/create',
        '/donors/edit/:id'
    ],
    donations: [
        '/donations',
        '/donations/create',
        '/donations/edit/:id' 
    ],
    appeals: [
        '/appeals',
        '/appeals/create',
        '/appeals/edit/:id' 
    ],
    messaging: [
        '/messaging',
        '/messaging/create',
        '/messaging/edit/:id' 
    ],
    payments: [ '/messaging' ],
    digitalMarketting: [ '/digital-marketting' ]

}
const roles = {
  SUPER_ADMIN: 0,
  CHARITY_ADMIN: 2,
  FUNDRAISER_TEAM: 3,
  FUNDRAISER: 4,
};

export {
    currencies,
    roles
}

